import firebase from "config/firebase";
import { toast } from "react-toastify";
import { RepositoryFactory } from "repositroy/RepositoryFactory";

export const fetchContractRequests = () => async (dispatch) => {
  dispatch({ type: "CONTRACT_REQUESTS_LOADING", payload: true });
  return firebase
    .firestore()
    .collection("request_School_Contracts")
    .onSnapshot((snapshot) => {
      let newArr = [];
      snapshot.forEach((doc) => {
        newArr.push({ id: doc.id, ...doc.data() });
      });
      dispatch({ type: "GETAllContractRequests", payload: newArr });
      dispatch({ type: "CONTRACT_REQUESTS_LOADING", payload: false });
    });
};

export const fetchSignedContracts = () => (dispatch) => {
  dispatch({ type: "SIGNED_CONTRACTS_LOADING", payload: true });
  return firebase
    .firestore()
    .collection("schoolContracts")
    .onSnapshot((snapshot) => {
      let newArr = [];
      snapshot.forEach((doc) => {
        newArr.push({ id: doc.id, ...doc.data() });
      });

      dispatch({ type: "GETAllSignedContracts", payload: newArr });
      dispatch({ type: "SIGNED_CONTRACTS_LOADING", payload: false });
    });
};

export const getApprovedContracts =
  (lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    dispatch({ type: "APPROVED_CONTRACTS_LOADING", payload: true });
    let query = firebase
      .firestore()
      .collection("users")
      .where("role", "==", "school-admin")
      .orderBy("created_at")
      .limit(5);

    if (lastDocument) {
      query = query.startAfter(lastDocument);
    }
    const unsubscribe = query.onSnapshot((snapshot) => {
      let temp_data = [];
      snapshot.forEach((doc) => {
        temp_data.push({ ...doc.data(), id: doc.id });
      });
      dispatch({
        type: lastDocument
          ? "MORE_GET_APPROVED_CONTRACTS"
          : "GET_APPROVED_CONTRACTS",
        payload: {
          data: temp_data,
          hasMore: temp_data.length === 5,
          lastDocument:
            snapshot.docs.length > 0
              ? snapshot.docs[snapshot.docs.length - 1]
              : null,
        },
      });
      dispatch({ type: "APPROVED_CONTRACTS_LOADING", payload: false });
      onComplete();
    });
    return unsubscribe;
  };

export const RejectContract = (id) => async (dispatch) => {
  try {
    await firebase
      .firestore()
      .collection("request_School_Contracts")
      .doc(id)
      .delete();
    toast.success("Contract DELETED Successfully");
  } catch (error) {
    toast.error("Error deleting Contract");
  }
};

export const AcceptContract = (id, data) => async (dispatch) => {
  try {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp();
    await firebase
      .firestore()
      .collection("request_School_Contracts")
      .doc(id)
      .delete();

    const querySnapshot = await firebase
      .firestore()
      .collection("schoolContracts")
      .orderBy("cid", "desc")
      .limit(1)
      .get();

    let cid = 101;
    if (!querySnapshot.empty) {
      const lastContract = querySnapshot.docs[0].data();
      cid = lastContract.cid + 1;
    }
    await firebase.firestore().collection("schoolContracts").add({
      email: data.email,
      imageURL: data.imageURL,
      state: data.state,
      school: data.school,
      country: data.country,
      type: data.type,
      status: "signed",
      cid: cid,
      acceptedAt: timestamp,
      createdAt: timestamp,
    });
    toast.success("Request Accepted");
  } catch (error) {
    toast.error("Error accepting Contract");
  }
};

export const fetchSignedContractByID = (id) => async (dispatch) => {
  await firebase
    .firestore()
    .collection("schoolContracts")
    .doc(id)
    .get()
    .then((doc) => {
      if (doc.exists) {
        const contractData = { id: doc.id, ...doc.data() };
        dispatch({ type: "GETContractByID", payload: contractData });
      } else {
      }
    });
};

export const DeleteContract = (id) => async (dispatch) => {
  try {
    await firebase.firestore().collection("schoolContracts").doc(id).delete();
    toast.success("Contract DELETED Successfully");
  } catch (error) {
    toast.error("Error deleting Contract");
  }
};
export const deleteApprovedContract = (id) => async () => {
  let deleteContract = RepositoryFactory.get("deleteContract");
  deleteContract
    .deleteSchoolAdminContract(id)
    .then((response) => {
      toast.success(response.data.message);
    })
    .catch((error) => {
      console.error(error);
    });
};

export const ApprovedContract = (data, payload) => async (dispatch) => {
  const timestamp = firebase.firestore.FieldValue.serverTimestamp();

  try {
    await firebase
      .firestore()
      .collection("schoolContracts")
      .doc(data.id)
      .update({ FHPAdmin: payload, status: "approved", approvedAT: timestamp });

    await firebase
      .firestore()
      .collection("users")
      .where("email", "==", data.email)
      .get()
      .then(async (query) => {
        if (!query.empty) {
          await firebase
            .firestore()
            .collection("users")
            .doc(query.docs[0].id)
            .update({
              ip_contract: true,
            });
        }
      });

    toast.success("Submit Successfully");
  } catch (error) {
    toast.error("Error Submiting");
  }
};

export const getOnlyWalletTransaction =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = firebase
      .firestore()
      .collection("wallet_logs")
      .where("userId", "==", id)
      .where("paymentType", "==", "wallet");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          if (doc.data()?.athleteId) {
            let athlete = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data()?.athleteId)
              .get();
            temp_data.push({ data: doc.data(), athlete: athlete.data() });
          } else {
            let userId = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data()?.userId)
              .get();
            temp_data.push({ data: doc.data(), athlete: userId.data() });
          }
        }
        let hasMoreDocument = temp_data.length >= 10;
        if (lastDocument != "") {
          dispatch({
            type: "GET-WALLET-TRANSACTION",
            payload: {
              temp_data,
              hasMoreDocument,
              lastDocument: query.docs[temp_data.length - 1],
            },
          });
        } else {
          dispatch({
            type: "GET-WALLET-TRANSACTION-EMPTY",
            payload: {
              temp_data,
              hasMoreDocument,
              lastDocument: query.docs[temp_data.length - 1],
            },
          });
        }
        onComplete();
      });
  };
///
export const getOtherWalletTransaction =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = firebase
      .firestore()
      .collection("wallet_logs")
      .where("userId", "==", id)
      .where("paymentType", "!=", "wallet");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          if (doc.data()?.athleteId) {
            let athlete = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data()?.athleteId)
              .get();
            temp_data.push({ data: doc.data(), athlete: athlete.data() });
          } else {
            let userId = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data()?.userId)
              .get();
            temp_data.push({ data: doc.data(), athlete: userId.data() });
          }
        }
        let hasMoreDocument = temp_data.length >= 10;
        if (lastDocument != "") {
          dispatch({
            type: "GET-OTHER-TRANSACTION",
            payload: {
              temp_data,
              hasMoreDocument,
              lastDocument: query.docs[temp_data.length - 1],
            },
          });
        } else {
          dispatch({
            type: "GET-OTHER-TRANSACTION-EMPTY",
            payload: {
              temp_data,
              hasMoreDocument,
              lastDocument: query.docs[temp_data.length - 1],
            },
          });
        }
        onComplete();
      });
  };
///
export const getTotalAmount = (id) => (dispatch) => {
  firebase
    .firestore()
    .collection("wallet")
    .where("userId", "==", id)
    .get()
    .then((query) => {
      if (query.docs.length > 0) {
        dispatch({
          type: "GET-TOTAL-AMOUNT",
          payload: query.docs[0].data(),
        });
      } else {
        dispatch({
          type: "GET-TOTAL-AMOUNT",
          payload: 0,
        });
      }
    });
};
